



document.addEventListener('DOMContentLoaded', function(){

	let navigation 			= document.querySelector('nav');
	let navigationItems 	= document.querySelectorAll('nav a');
	let header 				= document.querySelector('header');
	let btn_OpenMobileMenu 	= document.querySelector('#btn-menu');
	let btn_CloseMobileMenu = document.querySelector('.btn-close-menu');
	const VIEWPORT_CONSTRAINT = 1023;

	/*
		*	Assign an event listener for click event to the mobile menu button.
	*/
	btn_OpenMobileMenu.addEventListener('click', function(e){
		/*
			*	Check if the viewport is within the constarint.
		*/
		if(window.innerWidth > VIEWPORT_CONSTRAINT){
			return;
		}

		/*
			*	If the page is scrolled by <SCROLL_THRESHOLD> pixels,
				remove the threshold class of the header to prevent
				<UL Element's> <display: flex> rule.
		*/
		if(window.pageYOffset > 16){
			header.classList.remove('scroll-threshold-passed');
		}

		/*
			*	Add the mobile menu class to the navigation.
		*/
		navigation.classList.add('temrin-mobile-menu');
		document.body.style.overflow = "hidden";

		/*
			*	Trigger the slide in animation.
		*/
		setTimeout(function(){
			navigation.classList.add('temrin-mobile-menu--slide');
		}, 100);
	});

	/*
		*	Assign an event listener to the <Close Menu Button> for click
			events.
	*/
	let handler_CloseMobileMenu = function(){

		/*
			*	Trigger the slide out animation.
		*/
		navigation.classList.remove('temrin-mobile-menu--slide');

		/*
			*	Remove the mobile menu class from the <navigation>.
			*	Remove the overflow rule of the <body>. 
			*	Check the fixed header position and readd the 
				threshold class.
		*/
		setTimeout(function(){
			navigation.classList.remove('temrin-mobile-menu');
			document.body.style.overflow = "";

			if(window.pageYOffset > 16){
				header.classList.add('scroll-threshold-passed')
			}
		}, 200);		
	}
	btn_CloseMobileMenu.addEventListener('click', handler_CloseMobileMenu);




	/*
		*	Assign an event listener to the <Navigation Links> for <Click> Events
	*/
	let handler_ClickNavigationItem = function(event){
		
		if(document.querySelector('.temrin-mobile-menu')){
			event.preventDefault();
			handler_CloseMobileMenu();

			let currentTarget = event.currentTarget;
			setTimeout( () => {
				window.location.href = currentTarget.getAttribute('href');
			}, 200 );
		}
	}
	for(let i=0; i < navigationItems.length; i++){
		navigationItems[i].addEventListener('click', handler_ClickNavigationItem);
	}


	/*
		*	Assign an event listener to the <Window> for <Resize> events.
	*/
	window.addEventListener('resize', function(){

		/*
			*	Check if viewport width is within the constraints.
		*/
		if(window.innerWidth > VIEWPORT_CONSTRAINT){
			handler_CloseMobileMenu();
		}
	});
});


